import { Controller } from '@hotwired/stimulus';

// Date d'un formulaire de rapport : choisie dans un sélecteur
// natif sans nom (date, ou date et heure), envoyée au format
// JJ/MM/AAAA (ou JJ/MM/AAAA HH:MM) par le champ caché nommé ; la
// valeur du champ caché (brouillon repris, envoi refusé) est lue au
// branchement.
const FRENCH = /^(\d{2})\/(\d{2})\/(\d{4})(?:\s+(\d{2}):(\d{2}))?$/;
const ISO = /^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2}))?/;

export default class extends Controller {
    static targets = ['input', 'value'];

    connect() {
        this.inputTarget.value = this.nativeValue(this.valueTarget.value.trim());
    }

    pick() {
        const match = this.inputTarget.value.match(ISO);
        if (!match) {
            this.valueTarget.value = '';
            return;
        }
        const [, year, month, day, hour, minute] = match;
        const date = `${day}/${month}/${year}`;
        this.valueTarget.value = this.inputTarget.type === 'date' ? date : `${date} ${hour || '00'}:${minute || '00'}`;
    }

    nativeValue(value) {
        let parts = value.match(FRENCH);
        if (parts) parts = [parts[3], parts[2], parts[1], parts[4], parts[5]];
        else parts = value.match(ISO)?.slice(1);
        if (!parts) return '';

        const [year, month, day, hour, minute] = parts;
        const date = `${year}-${month}-${day}`;
        return this.inputTarget.type === 'date' ? date : `${date}T${hour || '00'}:${minute || '00'}`;
    }
}
